<template>
    <div class="flex flex_end w_100">
        <template v-for="item in realList">
			<PaymentProgressStatusBox :status-code="item.status.code"
									  :status-tooltip="item.tip"
									  :with-click="true"
									  @click="expandDetails"
									  :key="item.index"
			/>
        </template>
    </div>
</template>

<script>
import {paymentProgress} from "@/common/utils/paymentProgress";
import PaymentProgressStatusBox from "@/components/templates/common/payments/PaymentProgressStatusBox";

export default {
	components: { PaymentProgressStatusBox },
	data() {
        return {
            tipList: [
                { index: 1, tip: this.$t("seller.payments.details.progress.auctionFee.tooltip")},
                { index: 2, tip: this.$t("seller.payments.details.progress.investorToSeller.tooltip")},
                { index: 3, tip: this.$t("seller.payments.details.progress.debtorToSeller.tooltip")},
                { index: 4, tip: this.$t("seller.payments.details.progress.sellerToInvestor.tooltip")}
            ]
        };
    },
    methods: {
        expandDetails() {
	        if (this.params.data.index === undefined) {
		        return;
	        }

            this.params.api.setRowNodeExpanded(this.params.node, !this.params.node.expanded);
        }
    },
    computed: {
        realList() {
            let { data } = this.params;
            let {
	            auctionFeePaymentStatus,
                buyerToSellerPaymentStatus,
                debtorToSellerPaymentStatus,
                sellerToBuyerPaymentStatus,
                buyerToSellerAmountAlreadyPaid,
                debtorAmountAlreadyPaid,
                sellerAmountAlreadyPaid,
                sellerAmountRequested,
                sellerAmountExpected,
                dueDate
            } = data;

            let tipList = this.tipList;
            tipList = tipList.map((item, n) => {
                switch (n) {
                    case 0:
                    	item.status = paymentProgress.getStatusForFee(auctionFeePaymentStatus);
                        break;
                    case 1:
                    	item.status = paymentProgress.getStatusForSettlement(null, buyerToSellerPaymentStatus, buyerToSellerAmountAlreadyPaid);
                        break;
                    case 2:
						item.status = paymentProgress.getStatusForSettlement(dueDate, debtorToSellerPaymentStatus, debtorAmountAlreadyPaid);
                        break;
                    case 3:
						item.status = paymentProgress.getStatusForSettlement(dueDate, sellerToBuyerPaymentStatus, sellerAmountAlreadyPaid, sellerAmountRequested, sellerAmountExpected);
                        break;
                    default:
                        break;
                }
                return item;
            });

	        return tipList.filter(item => item.status !== null);
        }
    }
};
</script>